<template>
	<div class="footer p-0">
		<table class="table mb-0">
			<tbody>
				<tr>
					<td class="align-middle">
						<button class="btn btn-xs btn-link text-warning" data-toggle="modal" data-target="#profileModal"><i
								class="fa fa-info-circle fa-2x"></i></button>
					</td>
					<td class="text-center align-middle"><span class="badge badge-success">{{ lszsz }}</span> {{ user.name }}
						- {{ local_roles[local_roles.map(role => role.id).indexOf(local_right_id)].name }}</td>
					<td class="text-right align-middle">
						<span class="badge badge-danger" v-if="user.tempo != null"><i class="fa fa-stopwatch mr-1"></i>{{ user.tempo }}</span>
						<span class="badge badge-info">{{ user.project_id }}</span>
						<span class="badge" v-if="count_type && count_types">{{ count_types.find(c => c.id ==
							count_type).name }}</span>
					</td>
				</tr>
			</tbody>
		</table>
		<!-- <div class="col-12 text-left pr-0" v-if="lszsz && user != null">
					<span class="font-weight-bold">Belépve: </span>
					<span class="badge badge-success mx-1">{{lszsz}}</span>
					<span class="badge mx-1">{{ user.name }} - {{local_roles[local_roles.map(role => role.id).indexOf(local_right_id)].name}}</span>
					<span class="badge badge-warning mx-1">{{device_id}}</span>
					<span class="badge badge-info float-right mr-0">{{ user.project_id }}</span>
					<span class="badge float-right mr-0" v-if="count_type && count_types">{{ count_types.find(c => c.id == count_type).name }}</span>
        </div> -->
		<!-- <div class="col-6 text-right">
            Peace cannot be kept by force; it can only be achieved by understanding <strong>Albert Einstein</strong>
        </div> -->
		<div class="modal fade" id="profileModal" tabindex="-1">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">Profil információ</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div v-if="lszsz && user != null">
							<div class="w-100 text-center">
								<barcode v-bind:value="lszsz">
									Hiba történt a vonalkód generálás során
								</barcode>
							</div>
							<table class="table">
								<tbody>
									<tr>
										<th>Név</th>
										<td>{{ user.name }}</td>
									</tr>
									<tr>
										<th>LSZSZ</th>
										<td>{{lszsz}}</td>
									</tr>
									<tr>
										<th>Jogkör</th>
										<td>{{local_roles[local_roles.map(role => role.id).indexOf(local_right_id)].name}}</td>
									</tr>
									<tr>
										<th>Eszközazonosító</th>
										<td>{{device_id}}</td>
									</tr>
									<tr>
										<th>Projekt id</th>
										<td>{{ user.project_id }}</td>
									</tr>
									<tr>
										<th>Teljesítmény</th>
										<td>
											<span v-if="user.tempo != null">{{ user.tempo }}</span>
											<span v-else>nem számolható</span>
										</td>
									</tr>
									<tr v-if="count_type && count_types">
										<th>Módszertan</th>
										<td>{{ count_types.find(c => c.id == count_type).name }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import appService from '../../apis/appService.js';
import VueBarcode from 'vue-barcode';
export default {
	name: 'Footer',
	components: {'barcode': VueBarcode},
	data() {
		return {
			device_id: null
		}
	},
	computed: {
		lszsz() {
			return this.$store.state.lszsz;
		},
		local_right_id() {
			return this.$store.state.local_right_id;
		},
		local_roles() {
			return this.$store.state.local_roles;
		},
		count_type() {
			return this.$store.state.count_type;
		},
		count_types() {
			return this.$store.state.count_types;
		},
		user() {
			return this.$store.state.user;
		},
	},
	created() {
		console.log('******************************');
		console.log('local_right_id:' + this.local_right_id, this.local_roles);
		console.log('******************************');
		this.device_id = appService.getDeviceId();
		//frissítsük be a tempot
		appService.getTempo(this.user.project_id, this.lszsz, appService.getDeviceId()).then(response => {
			this.$store.commit('updateUser', { ...this.user, tempo: response.data });
		});
	}
}
</script>

<style></style>